import { render, staticRenderFns } from "./FooterItem.vue?vue&type=template&id=3a3463a2&scoped=true&"
import script from "./FooterItem.vue?vue&type=script&lang=ts&"
export * from "./FooterItem.vue?vue&type=script&lang=ts&"
import style0 from "./FooterItem.vue?vue&type=style&index=0&id=3a3463a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3463a2",
  null
  
)

export default component.exports